import React, { useState } from 'react';
import './AssignRegistrationModal.scss';

interface AssignRegistrationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AssignRegistrationModal: React.FC<AssignRegistrationModalProps> = ({ isOpen, onClose }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!name.trim() || !email.trim()) {
      alert('Please fill in both name and email fields.');
      return;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert('Please enter a valid email address.');
      return;
    }

    // Create mailto link with predefined template
    const subject = encodeURIComponent('You have an action to register for Amazon Seller Central.');
    const body = encodeURIComponent(
      `Hi ${name},\n\n` +
      `You've been sent an action to review and register for Amazon Seller Central. Please click the link below to begin that process.\n\n` +
      `https://sellercentral.amazon.com/\n\n` +
      `For questions, contact our Business Development team at autosdealerbd-salesops@amazon.com.\n\n` +
      `Thank you,\n` +
      `Amazon Autos`
    );
    
    const mailtoLink = `mailto:${email}?subject=${subject}&body=${body}`;
    window.location.href = mailtoLink;
    
    // Reset form and close modal
    setName('');
    setEmail('');
    onClose();
  };

  const handleCancel = () => {
    setName('');
    setEmail('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Assign registration to someone else</h2>
          <button className="close-button" onClick={onClose}>
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="divider"></div>

          <div className="form-group">
            <label htmlFor="assignee-name">Name</label>
            <input
              type="text"
              id="assignee-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="John Doe"
              required
            />
            <p className="form-help-text">
              Use the person's name who will be required to register for Amazon Seller Central.
            </p>
          </div>

          <div className="form-group">
            <label htmlFor="assignee-email">Email</label>
            <input
              type="email"
              id="assignee-email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="johndoe@email.com"
              required
            />
            <p className="form-help-text">
              Use the person's email address who will be required to register for Amazon Seller Central.
            </p>
          </div>

          <div className="divider"></div>

          <div className="modal-actions">
            <button type="button" className="cancel-button" onClick={handleCancel}>
              Cancel
            </button>
            <button type="submit" className="submit-button">
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AssignRegistrationModal;